<template>
  <div>
    <el-dialog
    :append-to-body="true"
    :title="operate==='add'?'添加任务':'查看详情'"
    :close-on-click-modal="false"
    :before-close="closeView"
     class="addTaskView"
    :visible="currentStep === 2"
      width="550px">
      <el-form ref="ruleForm"  :rules="rules" :model="form">
        <el-row>
           <span class="star">*</span> 选择产品
          </el-row>
        <el-form-item label="" prop="productKey">
          <el-select
            :disabled="operate==='detail'"
            @change="changeProduct"
            v-model="form.productKey"
            placeholder="请选择"
            size="small">
              <el-option
                v-for="item in productList"
                :key="item.productKey"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
        </el-form-item>

        <el-row>
            选择设备
        </el-row>
        <el-form-item label="" prop="deviceName">
          <el-select
           :disabled="operate==='detail'"
           ref="deviceNameInput"
             @focus.prevent="focusStatus&&openDrawer()"
            multiple
            v-model="form.deviceName"
            placeholder="请选择">
              <el-option
                v-for="item in deviceList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-row>
           <span class="star">*</span> 输入参数
          </el-row> -->
         <el-row>
            <el-radio :disabled="operate==='detail'" @change="typeChange" v-model="thingModelType" label="properties">属性</el-radio>
            <el-radio
              :disabled="operate==='detail'"
              @change="typeChange"
              v-model="thingModelType"
              label="events">事件</el-radio>
            <!-- <el-radio :disabled="operate==='detail'" @change="typeChange"  v-model="thingModelType" label="services">服务</el-radio> -->
         </el-row>

        <el-row  v-if="thingModelType === 'properties'">
           <span class="el-icon-plus addBtn" @click="addFilter">筛选条件</span>
         </el-row>
         <el-select :disabled="operate==='detail'"  v-if="conditions.length > 0 && thingModelType === 'properties'" v-model="form.conditionType" placeholder="请选择筛选方式" >
              <el-option
                v-for="item in conditionTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
          </el-select>

         <el-tree
          v-if="thingModelType === 'properties' && conditions.length > 0"
         :render-after-expand="false"
         :disabled="true"
          ref="tree"
          :default-expand-all="true"
          :data="conditions"
          node-key="id">
          <div class="" slot-scope="{ node,data }">
            <filterCondition
            ref="filter"
            @delNode="delNode"
            :operate="operate"
            :thingModelType="thingModelType"
             :condition="data"/>
          </div>
        </el-tree>
        <template v-if="thingModel[thingModelType] && thingModelType === 'events'">
          <el-row>
           <span class="star">*</span>事件类型
          </el-row>
          <el-select
          :disabled="operate==='detail'"
          @change="eventTypeChange"
          v-model="form.conditionType"
          placeholder="请选择事件类型">
              <el-option
                v-for="(item,index) in eventTypeList"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </template>

        <template  v-if="thingModel[thingModelType] && thingModelType === 'events'">
          <el-row>
           <span class="star">*</span>
           事件名称
          </el-row>
          <el-form-item label="" prop="field">
              <el-select
                :disabled="operate==='detail'"
                v-model="form.field"
                placeholder="请选择事件名称">
                <el-option
                  v-for="(item,index) in getEventNameList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template  v-else-if="thingModel[thingModelType]">
          <!-- @todo 后续条件筛选也可以做成跟计算维度一样的级联多选的方式展示 -->
          <el-row>
           <span class="star">*</span>
           计算维度（数值类型）
          </el-row>
          <el-form-item label="" prop="field" >
              <el-cascader
              ref="computedCascader"
              :props="{ multiple: true,checkStrictly: true}"
              style="width：100%"
              @change="handleChange"
              :disabled="operate==='detail'"
              v-model="form.field"
              :options="numerical">
              </el-cascader>
          </el-form-item>
        </template>

        <el-row>
           聚合设备
          </el-row>
          <el-switch
              @change="changeDeviceType"
              v-model="deviceType">
          </el-switch>
        <template v-if="!deviceType && thingModel[thingModelType] && thingModelType === 'properties'">
          <el-row>
           聚合其他属性维度（非数值类型）
          </el-row>
           <el-cascader
           style="width：100%"
            :clearable="true"
              :disabled="operate==='detail'"
              v-model="form.groupField"
              :options="notNumerical">
           </el-cascader>
        </template>

        <el-row>
           <span class="star">*</span>统计函数
        </el-row>

        <el-form-item label="">
              <template v-if="thingModelType === 'events'">
                <el-radio
                :disabled="operate==='detail'"
                v-model="form.performType"
                :label="performTypeList[0].value">{{performTypeList[0].label}}</el-radio>
              </template>
              <template v-else>
                <div v-for="(pItem,pIndex) in propertyList" :key="pIndex">
                  <div><el-tag type="info">{{pItem.label}}</el-tag></div>
                  <el-radio
                  :disabled="operate==='detail'"
                  v-model="pItem.performType"
                  v-for="(item,index) in performTypeList"
                  :key="index"
                  :label="item.value">{{item.label}}</el-radio>
                </div>

              </template>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="operate==='detail'"  type="primary" @click="more" size="small">更多详情</el-button>
        <template v-else>
          <el-button @click="prevStep" size="small">上一步</el-button>
          <el-button  type="primary" @click="addTask" size="small">下一步</el-button>
        </template>

        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>

    <deviceSelectView
      @updateDevice="updateDevice"
      @closeDrawer="closeDrawer"
      :form="form"
      :productKey="form.productKey"
      :multipleSelected="multipleSelected"
      :drawerFlag="drawerFlag"
      v-if="drawerFlag"/>
  </div>
</template>
<script>
import { thingModel } from '@/api/deviceManagement'
import filterCondition from '@/components/dataList/filterCondition.vue'
import { productOptionsList } from '@/api/productRegistration'
import deviceSelectView from '@/components/dataList/deviceSelectView.vue'
import eventBus from '@/assets/js/eventBus'
let randomNum = 0
export default {
  components: {
    filterCondition,
    deviceSelectView
  },
  props: {
    productList: {
      type: Array || null
    },
    singleAddDetail: {
      type: Object
    },
    currentStep: {
      type: Number
    },
    taskDetail: {
      type: Object
    },
    operate: {
      type: String
    }
  },
  computed: {
    // deviceType: {
    //   get: function () {
    //     return this.taskDetail.groupField === 'device_name' // 选择单个设备或者多个设备的绑定值
    //   },
    //   set: function (value) {
    //     this.deviceType = value
    //   }
    // },
    getEventNameList () {
      const type = this.eventType[this.form.conditionType]
      console.log('type:', type)
      const allItem = {
        value: '',
        label: '全部'
      }
      let list = []
      if (type) { // 过滤
        list = this.eventNameList.filter(item => {
          return item.type === type
        })
      } else {
        list = this.eventNameList.filter(item => {
          return true
        })
        console.log('全部过滤后的list：', list)
      }
      list.unshift(allItem)
      return list
    },
    detaiDeviceList: {
      get: function () {
        // 显示详情的时候需要构造一个设备列表
        const deviceList = []
        if (this.taskDetail.deviceName) {
          const list = this.taskDetail.deviceName.split(',')
          list.map(item => {
            deviceList.push({
              label: item,
              value: item
            })
          })
        }
        console.log('计算后的deviceList：', deviceList)
        return deviceList
      },
      set: function (newValue) {
        console.log('计算设置deviceList：', newValue)
        return newValue
      }
    },
    deviceName: {
      get: function () {
        // 显示详情的时候需要构造一个设备列表的值
        return this.taskDetail.deviceName ? this.taskDetail.deviceName.split(',') : []
      },
      set: function (newValue) {
        console.log('计算设置deviceName：', newValue)
        return newValue
      }
    }
  },
  data: function () {
    var validateConditionType = (rule, value, callback) => {
      if (this.thingModelType === 'events' && isNaN(this.form.conditionType)) {
        callback(new Error('请选择事件类型'))
      } else {
        callback()
      }
    }

    var validateField = (rule, value, callback) => {
      if (this.thingModelType === 'properties' && this.form.field.length === 0) {
        callback(new Error('请选择计算维度'))
      } else {
        callback()
      }
    }
    return {
      form: {
        productKey: this.taskDetail.productKey ? this.taskDetail.productKey : '',
        conditions: this.taskDetail.conditions ? this.taskDetail.conditions : [], // 筛选条件集合
        deviceName: [], // 设备名
        conditionType: this.taskDetail.conditionType ? this.taskDetail.conditionType : 1,
        groupField: this.taskDetail.groupField && this.taskDetail.groupField !== 'device_name' ? this.taskDetail.groupField.split('.') : [], // 统计维度,选择分组的属性标识符（选择单个设备分组时 传"device_name"）
        performType: this.taskDetail.performType ? this.taskDetail.performType : 0,
        field: this.taskDetail.field || this.taskDetail.field === ''
          ? this.taskDetail.type.toString() === '1'
            ? this.taskDetail.field.split('.')
            : this.taskDetail.field
          : '' // 计算维度
      },
      rules: {
        productKey: [
          { required: true, message: '请选择产品', trigger: 'change' }
        ],
        field: [
          // { required: true, message: '请选择', trigger: 'change' }
          { validator: validateField, trigger: 'change' }
        ],
        // deviceName: [
        //   { required: true, message: '请选择设备', trigger: 'change' }
        // ],
        conditionType: [
          { validator: validateConditionType, trigger: 'change' }
        ]
      },
      radio: '1',
      checkList: ['最大值', '最小值'],
      conditionTypeList: [
        { label: '且', value: 1 },
        { label: '或', value: 2 }
      ],
      drawerFlag: false,
      focusStatus: true,
      thingModel: {
        events: [], // 事件
        properties: [], // 属性
        services: []// 服务
      }, // 物模型数据
      thingModelType: '',
      // thingModelType: this.taskDetail.type
      //   ? this.taskDetail.type.toString() === '2'
      //     ? 'events'
      //     : 'properties'
      //   : 'properties', // 默认的输入参数
      deviceType: this.taskDetail.groupField === 'device_name', // 选择单个设备或者多个设备的绑定值
      valueType: ['int', 'float', 'double', 'enum', 'bool'], // 数值类型，用于过滤物模型列表
      // 统计函数列表
      performTypeList: [
        { label: '总数', value: 0 },
        { label: '最大值', value: 1 },
        { label: '最小值', value: 2 },
        { label: '求和', value: 3 },
        { label: '平均', value: 4 }
      ],
      conditions: [], // 用于树形界面展示条件集合，提交时候再把此数组重新进行整合
      numerical: [], // 数值
      notNumerical: [], // 非数值
      eventNameList: [], // 事件名
      deviceList: [],
      eventTypeList: [
        { label: '全部', value: 0 },
        { label: '信息', value: 1 },
        { label: '告警', value: 2 },
        { label: '故障', value: 3 }
      ],
      eventType: {
        1: 'info',
        2: 'alert',
        3: 'error'
      },
      propertyList: [],
      propertyKey2Value: {},
      multipleSelected: []
    }
  },
  watch: {
    async taskDetail () {
      if (this.taskDetail) { // 查看详情时候重新赋值显示
        this.initData()// 初始化详情数据
        // 初始化设备数据
        if (this.taskDetail.productKey) {
          await this.getThingModel(this.taskDetail.productKey)
          this.initDevice()
        }
        if (this.thingModelType === 'properties') {
          this.initField()
          // 详情变化时候清空list
          this.propertyList.splice(0, this.propertyList.length)
        }
      }
    },
    currentStep () {
      // propertyList为空的时候，说明详情变化了，需要重新初始化propertyList
      if (this.thingModelType === 'properties' && this.currentStep === 2 && this.propertyList.length === 0) {
        this.handleChange()
      }
    }
  },
  created () {
    if (this.productList.lengthcreated <= 0) { // 证明在父级别页面没有获取到,重新获取
      this.getProductList()
    }
    eventBus.$on('resetFields', this.resetFields)
  },
  methods: {
    initField () {
      if (this.taskDetail.propertyList && this.taskDetail.propertyList.length > 0) {
        const field = []
        this.taskDetail.propertyList.map(item => {
          field.push(
            item.identifier.split('.')
          )
          this.propertyKey2Value[item.identifier] = item
        })
        this.form.field = field
      } else {
        this.propertyKey2Value = {}
      }
    },
    initData () {
      this.thingModelType = this.taskDetail.type
        ? this.taskDetail.type.toString() === '2'
          ? 'events'
          : 'properties'
        : 'properties'
      const formData = {
        productKey: this.taskDetail.productKey ? this.taskDetail.productKey : '',
        conditions: this.taskDetail.conditions ? this.taskDetail.conditions : [], // 筛选条件集合
        deviceName: [], // 设备名
        conditionType: this.taskDetail.conditionType ? this.taskDetail.conditionType : 1,
        groupField: this.taskDetail.groupField && this.taskDetail.groupField !== 'device_name' ? this.taskDetail.groupField.split('.') : [], // 统计维度,选择分组的属性标识符（选择单个设备分组时 传"device_name"）
        performType: this.taskDetail.performType ? this.taskDetail.performType : 0,
        field: this.taskDetail.field || this.taskDetail.field === ''
          ? this.taskDetail.type.toString() === '1'
            ? this.taskDetail.field.split('.')
            : this.taskDetail.field
          : '' // 计算维度
      }
      Object.assign(this.form, formData)
      this.deviceType = this.taskDetail.groupField === 'device_name'
    },
    resetFields () {
      console.log('this.operate:', this.operate)
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.conditions.splice(0, this.conditions.length)
    },
    eventTypeChange (val) {
      console.log('事件类型改变：', val)
      // 重置选项
      this.form.field = []
      this.$refs.ruleForm.clearValidate()
    },
    // 详情展示的时候初始化设备列表
    initDevice () {
      // 显示详情的时候需要构造一个设备列表
      const deviceList = []
      let deviceName
      if (this.taskDetail.deviceName) {
        deviceName = this.taskDetail.deviceName.split(',')
        deviceName.map(item => {
          deviceList.push({
            label: item,
            value: item
          })
        })
      } else {
        deviceName = []
      }

      console.log('deviceList')
      this.deviceList = deviceList
      this.form.deviceName = deviceName
    },
    updateDevice (device) {
      this.deviceList = device.deviceList
      this.form.deviceName = device.deviceName
      this.multipleSelected = device.selected
    },
    handleChange (value) {
      this.$nextTick(() => {
        let checkedList
        console.log('change:' + value)
        console.log('form.field:', this.form.field)
        console.log('numerical:', this.numerical)
        if (this.form.field.length >= 3) {
          const copyNumerical = JSON.parse(JSON.stringify(this.numerical))
          this.numerical = copyNumerical.map(item => {
            if (!this.form.field.flat(Infinity).includes(item.value)) {
              item.disabled = true
            }
            return item
          })
          this.$forceUpdate()
          // this.form.field = this.form.field.slice(0, 3)
          // this.$message({
          //   message: '计算维度最多只能选择3个',
          //   type: 'error'
          // })
          // console.log('截取后的长度：', this.form.field)
          this.$nextTick(() => {
            console.log(99999)
            checkedList = this.getCheckedNodeObject()
            this.propertyList.splice(0, this.propertyList.length, ...checkedList)
            console.log('checkedList:', checkedList)
            console.log('this.propertyList:', this.propertyList)
          })
        } else {
          const copyNumerical = JSON.parse(JSON.stringify(this.numerical))
          this.numerical = copyNumerical.map(item => {
            if (!this.form.field.flat(Infinity).includes(item.value)) {
              item.disabled = false
            }
            return item
          })
          this.$forceUpdate()
          checkedList = this.getCheckedNodeObject()
          this.propertyList.splice(0, this.propertyList.length, ...checkedList)
          console.log('checkedList:', checkedList)
          console.log('this.propertyList:', this.propertyList)
        }
      })
      // const aa = this.$refs.computedCascader.getCheckedNodes()
      // console.log('aa:', aa)
    },
    getCheckedNodeObject () {
      const checkedNode = this.$refs.computedCascader.getCheckedNodes()
      console.log('checkedNode:', checkedNode)
      // const checkedObj = {}
      const checkedList = []
      const getKeyValue = function (nodeTtem, listItem) {
        console.log('nodeTtem.data:', nodeTtem.data)
        if (listItem.label) {
          listItem.label = nodeTtem.data.label + '/' + listItem.label
          listItem.value = nodeTtem.data.value + '.' + listItem.value
        } else {
          listItem.label = nodeTtem.data.label
          listItem.value = nodeTtem.data.value
        }

        if (nodeTtem.parent && nodeTtem.parent !== null) {
          getKeyValue(nodeTtem.parent, listItem)
        }
      }
      for (const index in checkedNode) {
        if (!checkedNode[index].hasChildren) {
          const listItem = {
            label: '',
            value: '',
            performType: 0
          }
          getKeyValue(checkedNode[index], listItem)
          if (this.propertyKey2Value[listItem.value]) {
            listItem.performType = this.propertyKey2Value[listItem.value].performType
          }
          checkedList.push(listItem)
        }
      }
      return checkedList
    },
    initConditions () {
      this.conditions.splice(0, this.conditions.length)
      if (this.taskDetail.conditionDetailVoList && this.taskDetail.conditionDetailVoList.length > 0) {
        for (let i = 0; i < this.taskDetail.conditionDetailVoList.length; i++) {
          console.log(666)
          const item = this.taskDetail.conditionDetailVoList[i]
          const fieldList = item.field.split('.')
          const condition = {
            key: '',
            // condition: '',
            // value: ''
            field: '', // 对应属性标识符
            term: '', // 1 等于 2 不等于 3 小于 4 大于 5小于或等于 6大于或等于 7包含 8不包含
            fieldValue: '', // 对应属性值
            fieldType: '', // 1数字 2字符串
            fieldName: '', // 属性名称
            children: [], // 是否有子节点，界面展示需要，不用传递到后台
            id: Date.parse(new Date()) + '-' + Math.random(), // 作为树的唯一标示
            modelData: this.thingModel[this.thingModelType], // 把对应的物模型数据带过去
            validate: false // 用于验证筛选条件是否通过，作为判断标记
          }
          const listItem = this.initCondition(fieldList, condition, item, this.thingModel[this.thingModelType])
          // Object.assign(condition,item)
          this.conditions.push(listItem)
        }
      }
      console.log('组装后的this.conditions：', this.conditions)
    },
    initCondition (fieldList, condition, filterItem, modelData, ParentCurrentModel) {
      console.log('循环的fieldList：', fieldList)
      console.log('循环的modelData：', modelData)
      Object.assign(condition, filterItem)
      // condition.fieldValue = fieldList[0]
      condition.key = fieldList[0]
      let subModelData = ''
      let currentModel = ParentCurrentModel || ''
      let i = 0
      let item = ''
      if (modelData && modelData.length > 0) {
        while (i < modelData.length) {
          item = modelData[i]
          if (item.identifier === fieldList[0]) {
          // this.currentModel = item.outputData ? null : item
          // this.condition.field = item.identifier
          // this.condition.fieldName = item.name
            // if (item.outputData) {
            //   currentModel = item.outputData
            // } else if (item) {
            //   currentModel = item
            // }
            currentModel = item.outputData ? null : item
            // v-else-if="['array'].indexOf(currentModel.dataType.type) >= 0 && ['int','double','float','text'].indexOf(currentModel.dataType.specs.item.type) >= 0"
            if (item.outputData) { // 事件和服务就是一定有子选项的
              subModelData = item.outputData
            } else if (item.dataType.type === 'struct' && item.dataType.specs.length > 0) {
              subModelData = item.dataType.specs
            } else if (
              item.dataType.type === 'array' &&
              item.dataType.specs.item.type === 'struct' &&
              item.dataType.specs.item.specs.length > 0
            ) {
              subModelData = item.dataType.specs.item.specs
            }
            console.log('找到的物理模型item:', item)
            break
          }
          i++
        }
        console.log('循环之外：currentModel：', currentModel)
      }
      condition.currentModel = currentModel

      if (fieldList.length > 1) {
        const childCondition = {
          key: '',
          // condition: '',
          // value: ''
          field: '', // 对应属性标识符
          term: '', // 1 等于 2 不等于 3 小于 4 大于 5小于或等于 6大于或等于 7包含 8不包含
          fieldValue: '', // 对应属性值
          fieldType: '', // 1数字 2字符串
          fieldName: '', // 属性名称
          children: [], // 是否有子节点，界面展示需要，不用传递到后台
          id: Date.parse(new Date()) + '-' + Math.random(), // 作为树的唯一标示
          modelData: subModelData, // 把对应的物模型数据带过去
          validate: false // 用于验证筛选条件是否通过，作为判断标记
        }
        condition.children.push(childCondition)
        this.initCondition(fieldList.slice(1), childCondition, filterItem, subModelData)
        return condition
      } else {
        return condition
      }
    },
    changeDeviceType (value) {
      if (this.operate === 'detail') {
        this.deviceType = !value
        console.log(8888)
        return
      }
      if (value) {
        this.form.groupField = 'device_name'
      } else {
        this.form.groupField = ''
      }
    },
    typeChange (value) {
      console.log('value变化了：', value)
      // 将一些值重置
      this.form.groupField = ''
      this.form.conditionType = 1
      this.form.field = []
      this.form.performType = 0
      // 将筛选条件清除
      this.conditions.splice(0, this.conditions.length)
      // 表单的验证信息重置
      this.$refs.ruleForm.clearValidate()
    },
    async getThingModel (initProductKey) {
      let params = ''
      if (initProductKey) {
        params = {
          // productKey: 'R589hUgZrO8'
          productKey: initProductKey
        }
      } else {
        params = {
          // productKey: 'R589hUgZrO8'
          productKey: this.form.productKey
        }
      }

      console.log('getThingModel params:', params)
      this.key2chinese = {}
      this.dataList = []
      await thingModel(params).then(res => {
        res = res.data
        console.log('外层物模型数据：', res)
        // this.thingModel = res.data.thingModel
        Object.assign(this.thingModel, res.data.thingModel)
        if (initProductKey) {
          this.initConditions()
        }
        const selList = {
          numerical: [],
          notNumerical: [],
          eventNameList: []

        }

        /// 过滤获取数值类型 type:1 数值 2 非数值 3 事件
        const getSelList = function (modelData, list, type) {
          modelData.forEach((item) => {
            let subData = ''
            const listItem = {
              label: item.name,
              value: item.identifier
            }
            if (type === 3) { // type用于过滤
              listItem.type = item.type
              list.push(listItem)
            } else if (item.dataType.type === 'struct' && item.dataType.specs.length > 0) {
              console.log('有子节点的item：', item)
              subData = item.dataType.specs
              Object.assign(listItem, {
                children: []
              })
              getSelList(subData, listItem.children, type)
              if (listItem.children.length > 0) {
                // 过滤有下属有子节点再添加
                list.push(listItem)
              }
            } else if (
              item.dataType.type === 'array' &&
                item.dataType.specs.item.type === 'struct' &&
                item.dataType.specs.item.specs.length > 0
            ) {
              console.log('有子节点的item：', item)
              subData = item.dataType.specs.item.specs
              Object.assign(listItem, {
                children: []
              })
              getSelList(subData, listItem.children, type)
              if (listItem.children.length > 0) {
                // 过滤有下属有子节点再添加
                list.push(listItem)
              }
            } else if (type === 1 && ['int', 'double', 'float'].indexOf(item.dataType.type) >= 0) {
              list.push(listItem)
            } else if (type === 2 && ['emun', 'bool', 'text', 'date'].indexOf(item.dataType.type) >= 0) {
              list.push(listItem)
            }
          })
        }
        getSelList(this.thingModel.properties, selList.numerical, 1)
        getSelList(this.thingModel.properties, selList.notNumerical, 2)
        getSelList(this.thingModel.events, selList.eventNameList, 3)
        console.log('selList:', selList)
        this.numerical = selList.numerical
        this.notNumerical = selList.notNumerical
        this.eventNameList = selList.eventNameList
        // this.thingModel[this.thingModelType].forEach((e) => {
        //   console.log(e.dataType.type)
        //   if (e.dataType.type === 'int' || e.dataType.type === 'double' || e.dataType.type === 'float') {
        //     this.numerical.push(e)
        //   } else if (e.dataType.type === 'emun' || e.dataType.type === 'bool' || e.dataType.type === 'text' || e.dataType.type === 'date') {
        //     this.notNumerical.push(e)
        //   } else if (e.dataType.type === 'array') {
        //     const arrType = e.dataType.specs.item
        //     if (arrType.type === 'struct') {
        //       if (arrType.specs.length !== 0) {
        //         arrType.specs.forEach((arrEle) => {
        //           console.log(arrEle)
        //           if (arrEle.dataType.type === 'emun' || arrEle.dataType.type === 'bool' || arrEle.dataType.type === 'text' || arrEle.dataType.type === 'date') {
        //             this.notNumerical.push(arrEle)
        //           } else {
        //             this.numerical.push(arrEle)
        //           }
        //         })
        //       }
        //     }
        //   } else {
        //     if (e.dataType.specs.length !== 0) {
        //       e.dataType.specs.forEach((struEle) => {
        //         console.log(struEle)
        //         if (struEle.dataType.type === 'emun' || struEle.dataType.type === 'bool' || struEle.dataType.type === 'text' || struEle.dataType.type === 'date') {
        //           this.notNumerical.push(struEle)
        //         } else {
        //           this.numerical.push(struEle)
        //         }
        //       })
        //     }
        //   }
        // })
        console.log('数组', this.thingModel[this.thingModelType])
        console.log(this.notNumerical, this.numerical)
      })
      console.log('await后面')
    },
    closeDrawer () {
      this.focusStatus = true
      this.drawerFlag = false
      this.$refs.deviceNameInput.blur()
    },
    // inputBlur () {
    //   this.$refs.deviceNameInput.blur()
    //   this.focusStatus = true
    // },
    // 打开抽屉
    openDrawer (e) {
      this.drawerFlag = true
      this.$refs.deviceNameInput.blur()
      // this.getCategoryMangeList()
    },
    changeProduct (value) {
      this.multipleSelected = []
      console.log('value:', value)
      this.productList.forEach(item => {
        if (item.productKey === value) {
          this.taskDetail.productName = item.productName
        }
      })
      console.log('this.taskDetail:', this.taskDetail)
      this.getThingModel()
      this.conditions.splice(0, this.conditions.length)
      this.form.deviceName = []
      this.form.field = []
      this.propertyList.splice(0, this.propertyList.length)
    },
    getProductList () {
      productOptionsList({})
        .then(res => {
          this.productList.splice(0, this.productList.length, ...res.data.data)
          // Object.assign(this.productList, res.data.data)
          console.log('this.productList:', this.productList)
        })
    },
    nextStep () {
      this.$emit('nextStep', 3)
    },
    addFilter () {
      if (this.operate === 'detail') {
        return
      }
      randomNum++
      this.conditions.push({
        // key: '',
        // condition: '',
        // value: ''
        field: '', // 对应属性标识符
        term: '', // 1 等于 2 不等于 3 小于 4 大于 5小于或等于 6大于或等于 7包含 8不包含
        fieldValue: '', // 对应属性值
        fieldType: '', // 1数字 2字符串
        fieldName: '', // 属性名称
        children: [], // 是否有子节点，界面展示需要，不用传递到后台
        id: Date.parse(new Date()) + '-' + randomNum, // 作为树的唯一标示
        modelData: this.thingModel[this.thingModelType], // 把对应的物模型数据带过去
        validate: true // 用于验证筛选条件是否通过，作为判断标记
      })
    },
    closeView () {
      this.$emit('closeView')
    },
    assignConditions (conditions, parentField) {
      conditions.forEach(item => {
        if (item.children.length > 0) {
          const parent = (parentField && parentField !== undefined && parentField !== 'undefined') ? parentField + item.field + '.' : item.field + '.'
          this.assignConditions(item.children, parent)
        } else {
          const condition = {
            field: parentField ? parentField + item.field : item.field, // 对应属性标识符
            term: item.term, // 1 等于 2 不等于 3 小于 4 大于 5小于或等于 6大于或等于 7包含 8不包含
            fieldValue: item.fieldValue, // 对应属性值
            fieldType: item.fieldType, // 1数字 2字符串
            fieldName: item.fieldName // 属性名称
          }
          this.form.conditions.push(condition)
        }
      })
    },
    more () {
      this.$emit('nextStep', 3)
    },
    validateConditions (conditions) {
      for (let i = 0; i < conditions.length; i++) {
        if (conditions[i].children.length === 0 && !conditions[i].validate) {
          console.log('验证不通过:', conditions[i])
          return false
        } else if (this.conditions[i].children.length > 0) {
          return this.validateConditions(conditions[i].children)
        }
      }
      return true
    },
    confirmAddTask () {
      console.log('验证前的this.conditions：', this.conditions)
      const validateResult = this.validateConditions(this.conditions)
      console.log('验证结果：', validateResult)
      if (!validateResult) {
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        console.log('valid:', valid)
        console.log('this.form.field:', this.form.field)
        this.form.conditions = []
        // 将conditions整合到form.conditions里面去
        this.assignConditions(this.conditions)

        const typeList = {
          events: 2, // 事件
          properties: 1, // 属性
          services: 3// 服务
        }
        Object.assign(this.taskDetail, this.form, {
          type: typeList[this.thingModelType]
        })
        // 为属性的时候，需要传propertyList
        const propertyList = []
        if (this.thingModelType === 'properties') {
          this.propertyList.map(item => {
            const listItem = {
              identifier: item.value,
              performType: item.performType
            }
            propertyList.push(listItem)
          })
          console.log('propertyList:', propertyList)
        } else {
          console.log('this.form.field:', this.form.field)
          const listItem = {
            identifier: this.form.field,
            performType: this.form.performType
          }
          propertyList.push(listItem)
        }
        this.taskDetail.propertyList = propertyList
        // 数组拼接转化为字符串
        if (this.taskDetail.field.join) {
          this.taskDetail.field = this.taskDetail.field.join('.')
        }
        if (this.taskDetail.groupField && this.taskDetail.groupField.join) {
          this.taskDetail.groupField = this.taskDetail.groupField.join('.')
        }
        // 遍历数组获取到设备的deviceName
        const deviceName = []
        this.deviceList.forEach(item => {
          deviceName.push(item.label)
        })
        this.taskDetail.deviceName = deviceName.join(',')

        console.log('this.taskDetail:', this.taskDetail)
        if (valid) {
          this.nextStep()
        }
      })
    },
    addTask () {
      eventBus.$emit('filterValidate')
      this.confirmAddTask()
    },
    delNode (node) {
      console.log(8888)
      this.$refs.tree.remove(node)
    },
    prevStep () {
      this.$emit('nextStep', 1)
    }
  }
}
</script>
<style lang="less" scope>
.addTaskView{
  .addBtn{
    color: #0070cc;
    cursor: pointer;
  }
  .star{
       color:#d93026;
    }
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .el-row:nth-child(even){
      margin-top: 15px;
    }
    .el-row:nth-child(odd){
      margin-top: 5px;
    }
    .el-select{
      width: 100%;
    }
    .el-icon-info{
      color: #0070cc;
      margin-right: 10px;
      font-size: 16px;
    }
    .tips{
      padding: 15px;
      display: flex;
      background-color: #e5f3ff;
      font-size: 10px;
    }
    .el-tree-node__content{
      height: auto;
    }
  }
</style>
